var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"mmain",attrs:{"data-title":"北京天蔚中医药发展促进中心-合作交流"}},[_c('mClass',{attrs:{"nav":_vm.nav}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }